import React from 'react';
import { Target } from 'lucide-react';
import { AccountPosition } from '../types';

interface PositionThesisProps {
  position: AccountPosition;
}

const PositionThesis: React.FC<PositionThesisProps> = ({ position }) => {
  if (!position.thesis) return null;

  return (
    <div className="mb-6">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 mb-4">
        <h3 className="text-sm font-semibold text-blue-800 mb-4 flex items-center">
          <Target className="w-4 h-4 mr-2" />
          AI Trade Thesis & Expectations
        </h3>

        {/* Thesis Type and Overview */}
        <div className="bg-white border border-blue-200 rounded-lg p-4 mb-4">
          <div className="flex items-center justify-between mb-3">
            <h4 className="text-sm font-semibold text-blue-800">
              Thesis Type: {position.thesis.type}
            </h4>
            <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
              {position.thesis.timeHorizon}
            </span>
          </div>

          {/* Current Price */}
          {position.thesis.currentPrice && (
            <div className="mb-4">
              <p className="text-xs text-blue-600 font-medium mb-2">
                Current Price at Analysis
              </p>
              <p className="text-sm font-semibold text-gray-700">
                ${position.thesis.currentPrice.toFixed(2)}
              </p>
            </div>
          )}

          <div className="mb-4">
            <p className="text-xs text-blue-600 font-medium mb-2">
              Expected Outcome
            </p>
            <p className="text-sm text-gray-700 leading-relaxed">
              {position.thesis.expectedOutcome}
            </p>
          </div>

          <div className="mb-4">
            <p className="text-sm text-blue-600 font-medium mb-2">
              Original Reasoning
            </p>
            <p className="text-sm text-gray-700 leading-relaxed">
              {position.thesis.originalReasoning}
            </p>
          </div>
        </div>

        {/* Key Assumptions */}
        {position.thesis.keyAssumptions &&
          position.thesis.keyAssumptions.length > 0 && (
            <div className="bg-white border border-blue-200 rounded-lg p-4 mb-4">
              <p className="text-xs text-blue-600 font-medium mb-3">
                Key Assumptions
              </p>
              <ul className="space-y-2">
                {position.thesis.keyAssumptions.map((assumption, index) => (
                  <li
                    key={index}
                    className="text-sm text-gray-700 flex items-start"
                  >
                    <span className="text-blue-500 mr-2">•</span>
                    {assumption}
                  </li>
                ))}
              </ul>
            </div>
          )}
      </div>
    </div>
  );
};

export default PositionThesis;
